$(function () {

	if ($('#window-scroll').length > 0) {
		$('.body').addClass('onpage-scroll');

		if (!is_tablet && !is_mobile) {
			$('#window-scroll').fullpage({
				//options here
				autoScrolling: true,
				scrollHorizontally: true,
				fitToSection: true,
				scrollingSpeed: 1000,
				sectionSelector: '.window',
				slideSelector: '.slide',
				afterLoad: function (index, nextIndex, direction) {

				},
				onLeave: function (index, nextIndex, direction) {
					let nextSection = $('.fp-section').eq(nextIndex - 1),
						max_index = $('.fp-section').length,
						prevSection = $('.fp-section').eq(index - 1),
						video = nextSection.find('video');

					lazy_load_block(nextSection);



					$('.window-scroll-nav-itm').removeClass('active');
					$('.window-scroll-nav-itm').eq(nextIndex - 1).addClass('active');

					if (nextIndex >= max_index) {
						$('.footer').addClass('show');
					} else {
						$('.footer').removeClass('show');
					}

					if (video.length > 0) {
						video[0].play();
					}

					gsap.fromTo(prevSection, {opacity: 1}, {opacity: 0, duration: .2});
					gsap.fromTo(nextSection, {opacity: 0}, {opacity: 1, duration: .4});

					/*if(is_tablet_big){
						return true;
					}*/

					if (direction === 'down') {

						gsap.fromTo(nextSection.find('.js-animation-title'), {y: 100}, {y: 0, duration: .3});
						gsap.fromTo(nextSection.find('.js-animation-content'), {y: 100, opacity: 0}, {
							y: 0,
							duration: .3,
							opacity: 1
						}).delay(.15);

					} else {
						gsap.fromTo(nextSection.find('.js-animation-title'), {y: -100}, {y: 0, duration: .3});
						gsap.fromTo(nextSection.find('.js-animation-content'), {y: -100, opacity: 0}, {
							y: 0,
							duration: .3,
							opacity: 1
						}).delay(.15);
					}

					gsap.fromTo(nextSection.find('.main-content--col-right'), {y: 30, opacity: 0}, {
						y: 0,
						opacity: 1,
						duration: .3,
						stagger: 0.1
					});


					if (nextIndex !== 1) {
						$('.order-fixed-btn').addClass('text-hide');
						close_header_menu();
					} else {
						$('.order-fixed-btn').removeClass('text-hide');
						open_header_menu();
					}

					gsap.fromTo(nextSection.find('.window-bg,.bg-video'), {scale: 1.05}, {scale: 1, duration: .6});

					if (!is_tablet_big) {
						let sequence = nextSection.find('.window-sequence.active');
						sequence.find('img').removeClass("active").first().addClass("active");
						sequence.css({
							opacity: 0,
						});
						if (sequence.length > 0) {
							sequence_play(sequence);
						}
					}


				}
			});

			//methods
			$.fn.fullpage.setAllowScrolling(true);

			gsap.to($('.fp-section').first(), {opacity: 1, duration: .2});


			lazy_load_block($('.window-bg'));
		}

		$('.fp-section').each(function () {
			$('#window-scroll-nav').append('<a href="#' + $(this).attr('id') + '" class="window-scroll-nav-itm"></a>');
		})

		let first = $('.window-scroll-nav-itm').first();
		first.addClass('active');

		if (is_mobile) {
			$('#front-window1').css('height', $(window).height());
		}

	}

	$(document).on('click', '.window-scroll-nav-itm', function () {
		$(this).siblings('.window-scroll-nav-itm').removeClass('active');
		$(this).addClass('active');

		$.fn.fullpage.moveTo($(this).index() + 1);

		return false;
	})


	$('.js-to-bot-window').on('click', function () {
		$.fn.fullpage.moveSectionDown();
	});

	lottie_init();

	if (is_tablet) {
		$(document).on('scroll', function () {
			if($('#front-window4').length == 0){
				return;
			}
			let scroll = $(window).scrollTop() + $(window).height(),
				start = $('#front-window4').offset().top,
				end = start + $('#front-window4').outerHeight(true);

			if (scroll > start && scroll < end + $(window).height()) {
				console.log('start');
				console.log(lottie_arr);
				console.log(lottie_arr.length);

				for (let i in lottie_arr) {
					lottie_arr[i].play();
				}
			} else {
				console.log('end')
				for (let i in lottie_arr) {
					lottie_arr[i].pause();
				}
			}
		});
	}

	$('.window-four-itm').on('mouseenter', function () {
		if (is_tablet || is_tablet_big) {
			return false;
		}

		let i = $(this).index();

		lottie_arr[i].play();
	});

	$('.window-four-itm').on('mouseleave', function () {
		if (is_tablet || is_tablet_big) {
			return false;
		}

		let i = $(this).index();

		lottie_arr[i].addEventListener('loopComplete', function () {
			lottie_arr[i].pause();
		});
	});

	$('.js-show-sequence-mobile').on('click', function () {
		var body = $(this).siblings('.sequence-m-itm__body');
		let tl = gsap.timeline();

		$(this).toggleClass('active');

		if ($(this).hasClass('active')) {
			tl.to(body, {
				height: 'auto',
				opacity: 1,
				duration: .4,
				ease: 'Sine.easeOut',
			});
			tl.to($(this).siblings('.sequence-m-itm__img'), {
				opacity: 0,
				duration: .15,
			}, '<');

			tl.fromTo(body.find('.col,.btn'), {
				opacity: 0,
				y: -5
			}, {
				opacity: 1,
				y: 0,
				ease: 'Sine.easeOut',
				stagger: .1
			}, '<+.1');

			$(this).find('.sequence-m-itm__btn__text').text('Скрыть услуги');


		} else {
			tl.to(body, {
				opacity: 0,
				duration: .5,
				ease: 'Sine.easeOut',
			});

			tl.to($(this).siblings('.sequence-m-itm__img'), {
				opacity: 1,
				duration: .2,
				ease: 'Sine.easeOut',
			}, '<');

			tl.to(body.find('.col,.btn'), {
				opacity: 0,
				duration: .2,
				ease: 'Sine.easeOut',
			}, '>-0.2');

			tl.to(body, {
				height: '0',
				duration: .5,
				ease: 'Sine.easeOut',
			}, '>-0.2');

			$(this).find('.sequence-m-itm__btn__text').text('Показать услуги');

		}
	});

});

var lottie_arr = {};

function lottie_init() {
	$('.js-lottie:not(.init)').each(function (i) {
		let self = this,
			href = $(this).attr('data-href');

		$.ajax({
			url: href,
			dataType: 'json',
			success: function (data) {
				let autoplay = false;
				if (is_tablet) {
					autoplay = false;
				}
				lottie_arr[i] = lottie.loadAnimation({
					container: self,
					renderer: 'svg',
					loop: true,
					autoplay: autoplay,
					animationData: data
				});
			}
		});
	});
}

